/**
 * Created by lenovo on 2017/3/27.
 */
import React, {Component, PropTypes} from 'react';
import {Link, hashHistory} from "react-router";

import {ellaUrl} from '../../../path.config'
import normalUserService from 'SERVICES/ella/normalUserService'
import {getProductId} from 'UTIL/common'
import Tip from 'CONFIG/component/tip'
import BoxHeader from "CONFIG/component/boxHeaderCreate"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import FormInput from 'CONFIG/component/form/formInput'
import Modal from 'CONFIG/component/modal'
import {language} from 'UTIL/common'
function returnMsg(body) {
    if (body.code == 8001) {
        $("#success_msg").text(body.msg);
        $("#success_tip").removeClass("hidden");
        setTimeout(function () {
            $("#success_tip").addClass("hidden");
        }, 3000);
    } else {
        $("#error_msg").text(body.msg);
        $("#error_tip").removeClass("hidden");
        setTimeout(function () {
            $("#error_tip").addClass("hidden");
        }, 3000);
    }
}
export default class NormalUserHandle extends Component{
    constructor(props){
        super(props);
        this.yesSure = this.yesSure.bind(this);
        this.noSure = this.noSure.bind(this);
        this.abnormalSure = this.abnormalSure.bind(this);
        this.freezeSure = this.freezeSure.bind(this);
        this.getData = this.getData.bind(this);
        this.state={
            list : {},
            freezeId : "",
            abnormalId : "",
            accountState : {1:"正常",2:"冻结",3:"预销户",4:"销户"},
        }
    }
    componentDidMount(){
        this.getData();
    }
    getData(){
        normalUserService.normalUserDetail(this.props.params.id).then(body =>{
            this.setState({
                list : body.data
            })
        })
    }
    content(){
        const list  = this.state.list;
        var div="";//0 启用 1 禁用
        if(list.state == 0){
            div = <div className="col-xs-2 text-center">
                <a onClick={this.noClick.bind(this,list.id)} className="btn btn-warning"
                   data-target="#noModal" data-toggle="modal">{language()['disableAccount']}</a>
            </div>;
        }else {
            div = <div className="col-xs-2 text-center">
                <a onClick={this.yesClick.bind(this,list.id)} className="btn btn-dropbox"
                   data-target="#yesModal" data-toggle="modal">{language()['enableAccount']}</a>
            </div>;
        }
        var div1 = "";
        if(list.accountState == "正常"){
            div1= <div className="col-xs-2 text-center">
                <a onClick={this.freeze.bind(this,list.id)} className="btn btn-danger"
                   data-target="#freezeModal" data-toggle="modal">{language()['freezeFundAccount']}</a>
            </div>;
        }else if(list.accountState == "冻结"){
            div1=<div className="col-xs-2 text-center">
                <a onClick={this.abnormal.bind(this,list.id)} className="btn btn-info"
                   data-target="#abnormalModal" data-toggle="modal">{language()['unfreezeFundAccount']}</a>
            </div>
        }
        const allDiv = <div className="row form-group">
            {div1}{div}
        </div>;
        return allDiv;
    }
    freeze(id){
        this.setState({
            freezeId : id
        })
    }
    abnormal(id){
        this.setState({
            abnormalId : id
        })
    }
    freezeSure(){
        const id = this.state.freezeId;
        normalUserService.normalUserFreeze(id).then(body=>{
            console.log(body);
            this.getData();
            returnMsg(body)
        })
    }
    abnormalSure(){
        const id = this.state.freezeId;
        normalUserService.normalUserAbnormal(id).then(body=>{
            console.log(body);
            this.getData();
            returnMsg(body)
        })
    }
    noClick(id){
        this.setState({
            noId :id
        })
    }
    yesClick(id){
        this.setState({
            yesId : id
        })
    }
    yesSure(){
        const id = this.state.yesId;
        normalUserService.normalUserEnable(id).then(body=>{
            console.log(body);
            this.getData();
            returnMsg(body)
        })
    }
    noSure(){
        const id = this.state.noId;
        normalUserService.normalUserDisable(id).then(body=>{
            console.log(body);
            this.getData();
            returnMsg(body)
        })
    }
    render(){
        return <div>
            <ContentHeader nameLg="userManage" nameSm="handleUser"/>
            <section className="content">
                <div className="box box-primary color-palette-box">
                    <BoxHeader name={language()['handleUser']}/>
                    <div className="box-body">
                        <Tip ids=""/>
                        {this.content()}
                        <table  className="table table-bordered table-striped dataTable">
                            <tbody>
                            <tr>
                                <td className="fontWeightBig">{language()['userAccount']}</td>
                                <td className="fontWeightSmall">{this.state.list.loginName}</td>
                                <td className="fontWeightBig">{language()['IDCardNo']}</td>
                                <td >{this.state.list.idCard}</td>
                            </tr>
                            <tr>
                                <td className="fontWeightBig">{language()['form']}</td>
                                <td className="fontWeightSmall">{this.state.list.type}</td>
                                <td className="fontWeightBig">{language()['depositBalance']}</td>
                                <td >{(this.state.list.deposit/100).toFixed(2)} 元</td>
                            </tr>
                            <tr>
                                <td className="fontWeightBig">{language()['walletBalance']}</td>
                                <td className="fontWeightSmall"> {(this.state.list.integral/100).toFixed(2)} 元</td>
                                <td className="fontWeightBig">{language()['status']}</td>
                                <td >{this.state.list.state == 0?"启用":"禁用"}</td>
                            </tr>
                            <tr>
                                <td className="fontWeightBig">资金账户状态</td>
                                <td className="fontWeightSmall"> {this.state.list.accountState}</td>
                                <td className="fontWeightBig">{language()['invitationCode']}</td>
                                <td >{this.state.list.inviteCode}</td>
                            </tr>
                            <tr>
                                <td className="fontWeightBig">{language()['registerTime']}</td>
                                <td className="fontWeightSmall"> {this.state.list.regTime}</td>
                            </tr>
                            </tbody>
                        </table>
                        <form>
                            <div className="row form-group">
                                <div className="col-xs-2 text-center">
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="box-footer">
                        <div className="col-xs-1 text-center">
                            <Link to={"/ella/user/user/normalUser"} className="btn btn-default" >{language()['return']}</Link>
                        </div>
                    </div>
                </div>
            </section>
            <Modal modal={{"id": "noModal", "title": "disable", "text": "readyDisable"}} modalSure={this.noSure}/>
            <Modal modal={{"id": "yesModal", "title": "enable", "text": "readyEnable"}} modalSure={this.yesSure}/>
            <Modal modal={{"id": "freezeModal", "title": "freeze", "text": "readyFreeze"}} modalSure={this.freezeSure}/>
            <Modal modal={{"id": "abnormalModal", "title": "unfreeze", "text": "readyUnfreeze"}} modalSure={this.abnormalSure}/>
        </div>
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/user/normalUserHandle.js